module.exports = __webpack_public_path__ + "media/images/illustrations/500-internal-server-error-494e02d5eb05e143d0d5e4112071d13e.svg";